<template>
    <div class="actionRelationClass">
        <ValidationObserver ref="form" v-slot="{handleSubmit}">
            <vs-row>
                <vs-col vs-w="12" v-if="popupType === 'createRelation'">
                    <div class="p-2">
                        <ValidationProvider vid="manager_hash" :name="$t('global.Manager')" rules="required" v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Manager')}}</label>
                            <v-select
                                ref="select"
                                :options="options.managers"
                                :reduce="item => item.hash"
                                label="name"
                                name="manager"
                                :clearable="false"
                                :placeholder="$t('global.Manager')"
                                appendToBody
                                v-model="selected.manager_hash"
                                :calculate-position="withPopper"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="12">
                    <div class="p-2">
                        <ValidationProvider vid="teams" :name="$t('global.Teams')" rules="required"  v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{$t('global.Teams')}}</label>
                            <v-select
                                ref="select"
                                :options="options.teams"
                                :reduce="item => item.id"
                                label="name"
                                multiple
                                name="teams"
                                :clearable="false"
                                :placeholder="$t('global.Teams')"
                                appendToBody
                                clearSearchOnSelect
                                :closeOnSelect="false"
                                v-model="selected.teams"
                                :calculate-position="withPopper"
                                :disabled="!options.teams.length || !isPermission('settings_management.update')"
                            />
                            <span class="text-danger text-xs" >{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="12" v-can="'settings_management.update'">
                    <div class="p-2 text-right">
                        <vs-button @click="handleSubmit(submit)" button="submit" ref="btn">{{ $t('buttons.Save') }}</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </ValidationObserver>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import EventBus from "@/store/eventBus";
import {vSelectPosition, checkPermission} from '@/utils/mixins'

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [vSelectPosition, checkPermission],
    data() {
        return {
            options: {
                managers: [],
                teams: []
            },
            selected: {
                manager_hash: '',
                teams: []
            }
        }
    },

    components: {
        vSelect
    },

    methods: {
        async submit() {
            try {
                await send(`${this.$url.settings_manager.get}/${this.selected.manager_hash}`, 'PATCH', {
                    data: {teams: this.selected.teams}
                })

                EventBus.$emit('actionRelation')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        sort(array, key = 'name') {
            return array.sort((a, b) => {
                const valA = typeof a[key] === 'string' ? a[key].toLowerCase() : a[key]
                const valB = typeof b[key] === 'string' ? b[key].toLowerCase() : b[key]
                return valA > valB ? 1 : valA < valB ? -1 : 0
            })
        }
    },

    async mounted() {
        const isCreate = this.popupType === 'createRelation'
        const teams = isCreate ? 'active_teams' : 'teams'

        if (!isCreate) {
            this.selected.manager_hash = this.popupData.data.hash
            this.selected.teams = this.popupData.data.teams.map(item => item.id)
        } else {
            this.options.managers = this.sort(this.popupData.users)
        }

        if (!this.isPermission('settings_team.show_team_name')) {
            this.options.teams = this.sort(this.popupData[teams].map(item => ({id: item.id, name: item.id})), 'id')
        } else {
            this.options.teams = this.sort(this.popupData[teams], 'name')
        }

        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
